<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <slot></slot>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { DiyItemProps } from './DiyItem'
import { useFormItemSpan, useFormItemRules } from '../hooks'

defineOptions({ name: 'OFormDiy', inheritAttrs: false })

const { name, label, labelWidth, required } = defineProps<DiyItemProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
</script>
